module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: {
      'firstHalfRow': _vm.spaceneeded === 'halfrowleft',
        'secondHalfRow': _vm.spaceneeded === 'halfrowright',
        'allRow': _vm.spaceneeded === 'fullrow'
    }
  }, [_c('div', {
    class: {
      'firstHalfBlock': _vm.spaceneeded === 'halfrowleft',
        'secondHalfBlock': _vm.spaceneeded === 'halfrowright'
    }
  }, [((_vm.inputType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    key: _vm.resetKey,
    staticClass: "adaptativePlaceholderBlock",
    class: {
      errorField: _vm.hasError
    },
    attrs: {
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, null) > -1 : (_vm.inputValue)
    },
    on: {
      "input": _vm.parseInput,
      "blur": _vm.onBlur,
      "change": function($event) {
        var $$a = _vm.inputValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.inputValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inputValue = $$c
        }
      }
    }
  }) : ((_vm.inputType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    key: _vm.resetKey,
    staticClass: "adaptativePlaceholderBlock",
    class: {
      errorField: _vm.hasError
    },
    attrs: {
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.inputValue, null)
    },
    on: {
      "input": _vm.parseInput,
      "blur": _vm.onBlur,
      "change": function($event) {
        _vm.inputValue = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    key: _vm.resetKey,
    staticClass: "adaptativePlaceholderBlock",
    class: {
      errorField: _vm.hasError
    },
    attrs: {
      "required": "",
      "type": _vm.inputType
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.parseInput],
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "alt": _vm.label,
      "placeholder": _vm.label
    }
  })])]), _vm._v(" "), (_vm.hasError) ? _c('small', {
    staticClass: "d-flex text-danger pl-2",
    staticStyle: {
      "margin-bottom": "1.8em"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50559bba", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50559bba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/components/AdaptativePlaceholderInput.vue
// module id = 2410
// module chunks = 2